import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isDark: true,
    lineColor: 'white',
    runningPosenet: false,
    appHeight: 600,
    appWidth: 600,
    homeAlreadyVisited: false,
    firestoreDB: null,
    debugSession: false,
    sounds: [
      {
        name: "Muted",
        ref: "s0",
        emittedTimes: 0
      },
      {
        name: "Ding",
        ref: "s2",
        emittedTimes: 0
      },
      {
        name: "Tap",
        ref: "s1",
        emittedTimes: 0
      },
    ],
    bodyPartsSounds: [
      {
        part: "nose",
        partN: "Nose",
        sound: "s0"
      },
      {
        part: "leftEye",
        partN: "Left Eye",
        sound: "s0"
      },
      {
        part: "rightEye",
        partN: "Right Eye",
        sound: "s0"
      },
      {
        part: "leftEar",
        partN: "Left Ear",
        sound: "s0"
      },
      {
        part: "rightEar",
        partN: "Right Ear",
        sound: "s0"
      },
      {
        part: "leftShoulder",
        partN: "Left Shoulder",
        sound: "s0"
      },
      {
        part: "rightShoulder",
        partN: "Right Shoulder",
        sound: "s0"
      },
      {
        part: "leftElbow",
        partN: "Left Elbow",
        sound: "s0"
      },
      {
        part: "rightElbow",
        partN: "Right Elbow",
        sound: "s0"
      },
      {
        part: "leftWrist",
        partN: "Left Wrist",
        sound: "s0"
      },
      {
        part: "rightWrist",
        partN: "Right Wrist",
        sound: "s0"
      },
      {
        part: "leftHip",
        partN: "Left Hip",
        sound: "s0"
      },
      {
        part: "rightHip",
        partN: "Right Hip",
        sound: "s0"
      },
      {
        part: "leftKnee",
        partN: "Left Knee",
        sound: "s0"
      },
      {
        part: "rightKnee",
        partN: "Right Knee",
        sound: "s0"
      },
      {
        part: "leftAnkle",
        partN: "Left Ankle",
        sound: "s0"
      },
      {
        part: "rightAnkle",
        partN: "Right Ankle",
        sound: "s0"
      }
    ]
  },
  mutations: {
    changeDarkMode(state, val){
      state.isDark = val
      if(val === true){
        state.lineColor = 'white'
      }else{
        state.lineColor = 'black'
      }
    },
    changeRunningPosenet(state, val){
      if(val === false && state.runningPosenet === true && state.debugSession === false){
        state.firestoreDB.collection("tracking-instrument").add({
          sounds: state.sounds
        })
        .then((docRef) => {
            console.log("Document written with ID: ", docRef.id);
        })
        .catch((error) => {
            console.error("Error adding document: ", error);
        });
      }
      if(val === true){
        if(Vue.$cookies.get("alreadyVisited") === false || !Vue.$cookies.isKey("alreadyVisited"))
          Vue.$cookies.set("alreadyVisited", true, Infinity)
      }
      state.runningPosenet = val
    },
    setAppDimensions(state, dimensions){
      state.appHeight = dimensions.Height
      state.appWidth = dimensions.Width
    },
    homeVisited(state){
      state.homeAlreadyVisited = true
    },
    setPartSound(state, RetObject){
      state.bodyPartsSounds.find(bodyPart => bodyPart.part === RetObject.part).sound = RetObject.sound
      Vue.$cookies.set("bodyPartsSounds", JSON.stringify(state.bodyPartsSounds), Infinity)
    },
    setFirestoreDB(state, db){
      state.firestoreDB = db
    },
    incrementEmitted(state, refSound){
      if(refSound !== "" && refSound !== "s0")
        state.sounds.find(sound => sound.ref === refSound).emittedTimes++
    },
    setBodyPartsSounds(state, obj){
      state.bodyPartsSounds = JSON.parse(obj)
    },
  },
  getters: {
    getSoundRef:(state) => (name) =>{
      return state.sounds.find(sound => sound.name === name)
    },
    getRefSound:(state) => (ref) =>{
      return state.sounds.find(sound => sound.ref === ref)
    },
    getSoundByPart:(state) => (part) => {
      return state.bodyPartsSounds.find(bpart => bpart.part === part).sound
    }
  },
  actions: {
  },
  modules: {
  }
})
